import { Sidebar } from "@xingternal/winery-ui/lib/Sidebar"
import styled, { css } from "styled-components"
import themeGet from "@styled-system/theme-get"

export const SidebarHeaderLayout = styled(Sidebar.Header)`
  ${({ isCollapsed }) =>
    isCollapsed &&
    css`
      height: ${themeGet("space.1")};
      padding: 0;
      width: 100%;
    `};

  background-color: ${({ isCollapsed, backgroundColor }) =>
    isCollapsed ? backgroundColor : "transparent"};
  padding-left: ${themeGet("space.6")};

  & > div {
    color: ${({ backgroundColor }) => backgroundColor}};
  }

  & > svg {
    visibility: hidden;
  }

  &:not(:first-child) {
      margin-top: ${themeGet("space.3")};
  }
`
